import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';


export const findClassify = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/findNameList`,
        method: 'GET'
    })
}
export const findFristList = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose`,
        method: 'GET'
    })
}
export const findSecondList = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/secondList`,
        method: 'GET'
    })
}
export const findShop = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop/shopPermissionList?` + params,
        method: 'GET'
    })
}
export const findShopDownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop/excel?` + params,
        method: 'GET'
    })
}
export const findClassifySecond = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/app_shop/info?shopId=` + params,
        method: 'GET'
    })
}
export const updateShopPermissionById = (id, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop/updateShopPermissionById/${id}?` + params,
        method: 'PUT'
    })
}